import { useState } from "react";
import { useTranslation } from "react-i18next";

const AttachmentDetailPopUpComponent = ({sendModalCloseDataFromChild, attachmentData}) => {
    const { t } = useTranslation();
    const fileExtension = attachmentData.imageName.split('.').pop().toLowerCase();

    const hangleModalClose = (e) => {
        e.preventDefault();
        sendModalCloseDataFromChild(false);
    };
    const renderFileContent = () => {
        if (fileExtension === 'pdf') {
            return (
                <div className="space-y-3">
                    <div className="first-letter:capitalize text-sm sm:text-base">
                        { t('PDF file. you can download it to view.')}
                    </div>
                    <div>
                        <a href={`data:application/pdf;base64,${attachmentData.image}`} download className="px-4 py-2 bg-blue-normal text-sm sm:text-base text-white rounded-md font-semibold capitalize">Download</a>
                    </div>
                </div>
            );
        }
        if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg') {
            return (
                <div className="flex flex-col justify-center items-center">
                    <img className="w-80 h-80" src={`data:image/png;base64,${attachmentData.image}`} alt="attachment" />
                </div>
            );
        }
        if (fileExtension === 'doc') {
            return (
                <div className="space-y-3">
                    <div className="first-letter:capitalize text-sm sm:text-base">
                        { t('microsoft word file. you can download it to view.')}
                    </div>
                    <div>
                        <a href={`data:application/msword;base64,${attachmentData.image}`} download className="px-4 py-2 bg-blue-normal text-sm sm:text-base text-white rounded-md font-semibold capitalize">Download</a>
                    </div>
                </div>
            );
        }
        return <p>Unsupported file format.</p>;
    };

    return (
        <div className="bg-white p-4 space-y-2 rounded-xl sm:rounded-none">
            {/* heading */}
            <div className="flex justify-between items-center cursor-pointer">
                <div className="font-semibold text-xs sm:text-base capitalize">{attachmentData.imageName}</div>
                <div className="flex items-center space-x-2">
                    <h1 className="px-2 sm:px-4 py-1 bg-background-normal text-blue-normal text-xs sm:text-sm rounded-md font-semibold capitalize">{attachmentData.categoryType}</h1>
                    <div onClick={(e) => hangleModalClose(e)}>
                        <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                    </div>
                </div>
            </div>
            {renderFileContent()}
        </div>
    )
}

export default AttachmentDetailPopUpComponent;
